import { render } from "./ProcessingResults.vue?vue&type=template&id=4c8a4480"
import script from "./ProcessingResults.vue?vue&type=script&lang=js"
export * from "./ProcessingResults.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/results/ProcessingResults.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4c8a4480"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4c8a4480', __exports__)) {
    console.log('reload')
    api.reload('4c8a4480', __exports__)
  }
  
  module.hot.accept("./ProcessingResults.vue?vue&type=template&id=4c8a4480", () => {
    console.log('re-render')
    api.rerender('4c8a4480', render)
  })

}


export default __exports__